import HoldingAttributeComplication from './HoldingAttributeComplication';

export default HoldingAttributeComplication;
